import React from 'react'
import styled from 'styled-components'
import { Heading, Wrapper, Paragraph, Head } from '@/shared/styled'
import { withPrefix } from 'gatsby'

const Container = styled.div`
  max-width: 960px;
  margin: auto;
`

const LeaderMessageSection = () => {
  return (
    <section className="py-24" id="leader-message">
      <Wrapper>
        <Head>
          <Heading>Leader's Message</Heading>
        </Head>

        <Container>
          <div className="-mx-5 flex flex-wrap mt-18">
            <div className="px-5 sm:w-2/5 w-full sm:mb-0 mb-10">
              <img
                src={withPrefix('/img/locnguyen.png')}
                srcSet={`${withPrefix('/img/locnguyen@2x.png')} 2x`}
                alt="Loc Nguyen - VP of Engineering"
                style={{ borderRadius: '20px' }}
              />
            </div>
            <div className="px-5 sm:w-3/5 w-full mt-3">
              <Paragraph className="mb-6 italic">
                I believe the time at Dwarves Foundation leaves you with not
                only experience but also the spirit of living like a real
                engineer. Every Dwarf is encouraged to involve and grow internal
                competencies, a working culture is expected to be constituted
                and nurtured, and we genuinely believe you can help enlarge the
                picture.
              </Paragraph>
              <blockquote>
                <Paragraph className="mb-12 italic">
                  Talent wins games, but teamwork and intelligence win
                  championships. Teammates are what make the journey more
                  adventurous and I can't wait to conquer a new one with you
                  guys.
                </Paragraph>
                <cite className="font-medium text-lg">Loc Nguyen</cite>
                <p className="mt-2 opacity-75">VP of Engineering</p>
              </blockquote>
            </div>
          </div>
        </Container>
      </Wrapper>
    </section>
  )
}

export default LeaderMessageSection
